import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import CertificatesContent from '../components/CertificatesContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import ExploreMore from '../components/ExploreMore'; 
import GetInTouch from '../components/GetInTouch'; 
import { Helmet } from "react-helmet";
import { api_base_url, base_url} from '../common/Constants';
 
class Certificates extends React.Component{
 
    render()
    {
       
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="body-block" data-v-e8f34808="">
      <div data-v-e8f34808="" className="page-block downloads" style={{ background: "rgb(238, 238, 238)" }}>
 
                <Header/> 
                <Helmet>
                    <title>{metas[5].title}</title>  
                    <meta name="description" content={metas[5].meta_description} />
                    <meta name="keywords" content={metas[5].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'certificates'} />
                </Helmet>
                <PageHeader title="Downloads" banner={base_url+`assets/_nuxt/img/careers.078a756.jpg`} />
                <CertificatesContent content={JSON.parse(localStorage.getItem("content"))} certificates={JSON.parse(localStorage.getItem("certificates"))} />  
                 <ExploreMore content={JSON.parse(localStorage.getItem("content"))}/>  
                <GetInTouch content={JSON.parse(localStorage.getItem("content"))}/>
                <Footer/>
            
            </div>
            </div>
       
        )
    }

}
export default Certificates;